import { getIn } from 'icepick';

export const getComplianceSettings = (state) => {
  return getIn(state, ['event', 'complianceSettings']);
};

export const getPrivacyPolicy = (state) => {
  return getComplianceSettings(state).privacyPolicy;
};

export const shouldShowPrivacyPolicy = (state) => {
  return getPrivacyPolicy(state).showPrivacyPolicy;
};

export const getPrivacyPolicyUrl = (state) => {
  return getPrivacyPolicy(state).privacyPolicyUrl || '';
};

export const getPrivacyPolicyLinkText = (state) => {
  return getPrivacyPolicy(state).privacyPolicyLinkText || '';
};

export const getCookieBannerSettings = (state) => {
  return getComplianceSettings(state).cookieBannerSettings;
};

export const shouldShowCookieBanner = (state) => {
  return getCookieBannerSettings(state).showCookieBanner;
};

export const shouldShowCookieBannerLink = (state) => {
  return getCookieBannerSettings(state).showCookieBannerLink;
};
